var _Object$defineProperty = require("../core-js/object/define-property");

function _defineProperty(obj, key, value) {
  if (key in obj) {
    _Object$defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty;


//////////////////
// WEBPACK FOOTER
// ../~/@babel/runtime-corejs2/helpers/defineProperty.js
// module id = 4
// module chunks = 1 2